import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meeting } from '@app/core/interfaces/portal/meeting';
import { MeetingUpdate } from '@app/core/interfaces/portal/meeting-update';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MeetingRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  create(meeting: MeetingUpdate): Observable<Meeting> {
    return this.utils.apiUrl('/meetings').pipe(
      mergeMap((url) => this.http.post<Meeting>(url, meeting)),
      wrapError('meeting-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.apiUrl(`/meetings/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('meeting-repository:delete')
    );
  }

  get(id: number): Observable<Meeting> {
    return this.utils.apiUrl(`/meetings/${id}`).pipe(
      mergeMap((url) =>
        this.http.get<Meeting>(url, {
          params: new HttpParams().set('deep', true),
        })
      ),
      wrapError('meeting-repository:get')
    );
  }

  list(): Observable<Meeting[]> {
    return this.utils.apiUrl('/meetings').pipe(
      mergeMap((url) =>
        this.http.get<Meeting[]>(url, {
          params: new HttpParams().set('deep', true),
        })
      ),
      wrapError('meeting-repository:list')
    );
  }

  resetPinOrToken(id: number, type: ResetMeetingPinOrTokenType): Observable<void> {
    return this.utils.apiUrl(`/meetings/${id}/resetPinOrToken`).pipe(
      mergeMap((url) =>
        this.http.put<void>(url, null, {
          params: new HttpParams().set('type', type),
        })
      ),
      wrapError('meeting-repository:reset-pin-or-token')
    );
  }

  update(id: number, meeting: MeetingUpdate): Observable<Meeting> {
    return this.utils.apiUrl(`/meetings/${id}`).pipe(
      mergeMap((url) => this.http.put<Meeting>(url, meeting)),
      wrapError('meeting-repository:update')
    );
  }
}

export type ResetMeetingPinOrTokenType = 'adminPin' | 'adminToken' | 'userPin' | 'userToken';
